import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "clearStart", "clearEnd", "startDate", "endDate"]
  static values = {
    selected: { type: Boolean, default: null },
    profileOdcDaysLimit: { type: Number, default: null }
  }

  initialize() {
    if (this.hasSelectedValue && this.selectedValue === false) {
      this.editMode();
    }
  }

  radioToggle(event) {
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
    const endOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    const endOfTodayPlus7Days = new Date(endOfToday);
    endOfTodayPlus7Days.setDate(endOfTodayPlus7Days.getDate() + 7);

    const limitDays = this.profileOdcDaysLimitValue || 0;
    const endOfTodayPlusLimit = new Date(endOfToday);
    endOfTodayPlusLimit.setDate(endOfTodayPlusLimit.getDate() + limitDays);

    if (event.currentTarget.value == 'week') {
      this.pickerTarget.classList.add('hidden');
      this.startDateTarget.value = this.formatDdMonthYyyyHm(startOfDay);
      this.endDateTarget.value = this.formatDdMonthYyyyHm(endOfTodayPlus7Days);
    } else {
      this.pickerTarget.classList.remove('hidden');
      this.startDateTarget.value = '';
      this.endDateTarget.value = this.profileOdcDaysLimitValue ? this.formatDdMonthYyyyHm(endOfTodayPlusLimit) : '';
    }
  }

  clearStartDate() {
    this.startDateTarget.value = "";
  }

  clearEndDate() {
    this.endDateTarget.value = "";
  }

  formatDdMonthYyyyHm(d) {
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('en-GB', { month: 'long' });
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const mins = String(d.getMinutes()).padStart(2, '0');
    return `${day} ${month} ${year} ${hours}:${mins}`;
  }

  editMode() {
    this.startDateTarget.value = "";
    this.endDateTarget.value = "";

    if(this.hasProfileOdcDaysLimitValue && this.profileOdcDaysLimitValue) {
      this.setMaxEndDate();

      $(".datetimepicker.date-start").on("dp.change", function (e) {
        this.setMaxEndDate();
      });
    }
  }

  setMaxEndDate() {
    const startDate = $(".datetimepicker.date-start").datetimepicker('date');
    const maxDate = startDate.add(this.profileOdcDaysLimitValue, 'days').add(23, 'hours').add(59, 'minutes');
    this.endDateTarget.value = maxDate.format("DD MMMM YYYY HH:mm");
    this.startDateTarget.value = $(".datetimepicker.date-start").datetimepicker('date').format("DD MMMM YYYY HH:mm");
    $(".datetimepicker.date-end").datetimepicker('maxDate', maxDate);
  }
}